import { get, post, put, destroy } from '@/api/request';

function fetchRoles(params) {
  return get('/roles', params);
}

function createRole(data) {
  return post('/roles', data);
}

function updateRole({ id, data }) {
  return put(`/roles/${id}`, data);
}

function removeRole(id) {
  return destroy(`/roles/${id}`);
}

export default {
  fetchRoles,
  createRole,
  updateRole,
  removeRole,
};



// WEBPACK FOOTER //
// ./src/store/modules/role/api.js